export default "__VITE_ASSET__DGWL2Vwh__"